import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  contentsValueState,
  popContValueState
} from "../../../../recoil/contentsAtom";
import "./PopPageContents.scoped.scss";
import { deletetag } from "../../../../utils/DeleteTag";
import styled from "styled-components";
import { ReplaceInput } from "styles/ReplaceInput";

function PopPageContents(props: { type: string }) {
  const { t } = useTranslation();
  const [popContValue, setPopContValue] = useRecoilState(popContValueState);
  const contentsValue = useRecoilValue(contentsValueState);

  const onTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPopContValue({ ...popContValue, title: e.target.value });
  };

  const onContentsChange = (e: React.ChangeEvent<HTMLDivElement>) => {
    setPopContValue({ ...popContValue, content: e.target.innerHTML });
  };

  return (
    <>
      {props.type === "write" ? (
        <div>
          <input
            name="title"
            value={popContValue.title || ""}
            onChange={onTitleChange}
            className="pop-title"
            maxLength={30}
            placeholder={t("please_enter_title")}
          />
        </div>
      ) : null}
      <ReplaceInput
        id="popConts"
        className="pop-content"
        onInput={(e: React.ChangeEvent<HTMLDivElement>) => onContentsChange(e)}
        contentEditable="true"
        placeholder={t(
          props.type === "comments"
            ? "Please_leave_a_reply"
            : "what_are_you_going_to_write"
        )}
        dangerouslySetInnerHTML={{
          __html: deletetag(contentsValue, ["img", "br"]) as string
        }}
      />
    </>
  );
}

export default PopPageContents;
